export default __webpack_public_path__ + "static/media/yellow-map-dot-viewed.7117f50c.svg";